// @flow
import type {ComponentType, Element, Node} from 'react'
import React, {Component} from 'react'
import {Button as BootstrapButton, Tooltip} from 'reactstrap'
import classNames from 'classnames'

type Props = {
  block: boolean,
  className: ?string,
  color: ?string,
  id: string,
  placement: string,
  size: ?string,
  title: Node,
  tooltip: Node,
  buttonTag: 'button' | ComponentType<*>,
  ...
}

type State = {|
  isTooltipOpen: boolean,
|}

class DisabledButtonWithTooltip extends Component<Props, State> {
  static defaultProps: {
  block: boolean,
  buttonTag: any,
  className: string,
  color: null,
  placement: string,
  size: null,
} = {
      block: false,
      className: '',
      color: null,
      placement: 'left',
      size: null,
      buttonTag: BootstrapButton,
    }

  state: State = {isTooltipOpen: false}

  get className(): string {
    return classNames('disabled', this.props.className)
  }

  tooltipToggle: (() => void) = () => {
    this.setState((prevState) => ({isTooltipOpen: !prevState.isTooltipOpen}))
  }

  render(): Element<"div"> {
    const Button = this.props.buttonTag
    return (
      <div id={this.props.id}>
        <Button
          block={this.props.block}
          color={this.props.color}
          size={this.props.size}
          className={this.className}
        >
          {this.props.title}
        </Button>
        <Tooltip
          placement={this.props.placement || 'left'}
          modifiers={[{name: 'preventOverflow', options: {boundary: 'window'}}]}
          isOpen={this.state.isTooltipOpen}
          target={this.props.id}
          toggle={this.tooltipToggle}
        >
          {this.props.tooltip}
        </Tooltip>
      </div>
    )
  }
}

export default DisabledButtonWithTooltip
